import { Validator } from 'vee-validate'

Validator.extend('phone', {
  params: 'type',
  validate: (value, type) => {
    let strongRegex = new RegExp('^0[1-8][1-9][1-9][0-9]{7}$|^09[0-9]{9}$')
    if (type[0] === 'mobile') {
      strongRegex = new RegExp('^09[0-9]{9}$')
    } else if (type[0] === 'mobileP') {
      strongRegex = new RegExp('^(09|\u06F0\u06F9)[\u06F0-\u06F90-9]{9}$')
    } else if (type[0] === 'landline') {
      strongRegex = new RegExp('^(0|\u06F0)[1-8|\u06F1-\u06F8][1-9|\u06F1-\u06F9]{2}[0-9|\u06F0-\u06F9]{7}$')
    } else if (type[0] === 'any') {
      strongRegex = new RegExp(
        '(^(0|\u06F0)[1-8|\u06F1-\u06F8][1-9|\u06F1-\u06F9]{2}[0-9|\u06F0-\u06F9]{7}$)|(^(09|\u06F0\u06F9)[\u06F0-\u06F90-9]{9}$)'
      )
    }
    return strongRegex.test(value)
  }
})

Validator.extend('nationalId', {
  validate: value => {
    return new RegExp('^[\u06F0-\u06F90-9]{10}$').test(value)
  }
})

Validator.extend('letters', {
  validate: value => {
    const strongRegex = new RegExp('^[\u0600-\u06FFa-zA-Z\\s]+$')
    return strongRegex.test(value)
  }
})

Validator.extend('percent', {
  validate: value => {
    const strongRegex = new RegExp('^[0-9][0-9]?$|^100$')
    return strongRegex.test(value)
  }
})
